<template>
  <div id="loading-bg">
      <div class="loading-logo">
        <img 
          width="150"
          alt="Logo"
          src="https://futurogfp-assets.s3.sa-east-1.amazonaws.com/logoescrita_oraculo_02.svg"
        >
      </div>
      <div class="loading">
        <div class="effect-1 effects"></div>
        <div class="effect-2 effects"></div>
        <div class="effect-3 effects"></div>
      </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import * as types from '../store/types'
import * as customerTypes from '@/constants/customers_types'
export default {
  mounted() {
    this.getType()
  },
  methods: {
    ...mapActions({
      getCustomerType: types.GET_CUSTOMER_TYPE_BY_TOKEN
    }),
    getType() {
      this.getCustomerType(this.$route.params.token)
        .then(response => {
          const customerTypeId = response.data.customer_type_id
          const customerId = response.data.id
          if (customerTypeId == customerTypes.LEAD) {
            this.$router.push({ name: 'lead-profile', params: { id: customerId } })
          } else if (customerTypeId == customerTypes.CUSTOMER) {
            this.$router.push({ name: 'customer-profile', params: { id: customerId} })
          } else if(customerTypeId == customerTypes.LEAD_PN) {
            this.$router.push({ name: 'lead-pn-profile', params: { id: customerId} })
          } else {
            this.$router.push({ name: 'dashboard' })
          }
        })
        .catch(error => {
          this.$router.push({ name: 'dashboard' })
        })
    }
  },
}
</script>
